import {
  Header,
  Footer,
  Hero,
  TradingSolutions,
  CoreSectors,
  Testimonials,
  OurNetwork,
  CTA,
  ParallaxSection
} from '../components';
import { ScrollToTop, WhatsAppButton } from '../components/ui';
import { SEOHead } from '../components/seo';

function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead />
      <Header />
      <ParallaxSection speed={0.5}>
        <Hero />
      </ParallaxSection>
      <ParallaxSection delay={200} speed={0.6}>
        <TradingSolutions />
      </ParallaxSection>
      <ParallaxSection speed={0.7}>
        <CoreSectors />
      </ParallaxSection>
      <ParallaxSection speed={0.6}>
        <OurNetwork />
      </ParallaxSection>
      <ParallaxSection speed={0.7}>
        <Testimonials />
      </ParallaxSection>
      <ParallaxSection speed={0.5} noSlide noParallax>
        <CTA />
      </ParallaxSection>
      <Footer />
      <ScrollToTop />
      <WhatsAppButton
        phoneNumber="971543994515"
        message="Hello! I'm interested in EasyBuy's services."
      />

    </div>
  );
}

export default HomePage;